<template>
  <div class="orderClassify">
    <el-tabs v-model="activeName" @tab-click="handleTabClick" style="width: 100%" type="card">
      <el-tab-pane label="财务分类" name="first">
        <div class="orderClassify1">
          <div class="orderClassifyLeft">
            <div class="orderClassifyLeftTitle" @click="tabVisible=true">
              一览表
              <!-- <img @click="remove" src="@/assets/images/common/icon_delete.png" />
              <img @click="amendItem" src="@/assets/images/common/icon_modify.png" />
              <img @click="append" src="@/assets/images/common/icon_add.png" />-->
            </div>
            <div class="custom-tree-container">
              <div class="block">
                <el-tree
                  :data="classifyList"
                  node-key="id"
                  :expand-on-click-node="true"
                  :props="defaultProps"
                  :load="loadNode"
                  @node-click="handleNodeClick"
                  highlight-current
                  lazy
                >
                  <span class="custom-tree-node" slot-scope="{node}">
                    <img class="treeNodeIcon" src="@/assets/images/common/icon_tree_node.png" />
                    <span>{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
            </div>
          </div>
          <!--财务分类 一览表 -->
          <div class="orderClassifyRight" v-show="tabVisible">
            <div class="classifyRightItem">
              <div class="rightItemTitle">总包合同</div>
              <el-input
                class="rightItemInput"
                placeholder="总包合同"
                v-model="generalContractName"
                :disabled="true"
              ></el-input>
            </div>
            <div class="classifyRightItem">
              <div class="rightItemTitle">项目名称</div>
              <el-input class="rightItemInput" placeholder="项目名称" v-model="name" :disabled="true"></el-input>
            </div>
            <div class="classifyRightItem">
              <div class="rightItemTitle">项目类型</div>
              <el-input
                class="rightItemInput"
                placeholder="项目类型"
                v-model="projectTypeName"
                :disabled="true"
              ></el-input>
            </div>
            <div class="classifyRightItem">
              <div class="rightItemTitle">总包金额</div>
              <el-input
                class="rightItemInput"
                placeholder="12"
                v-model="generalContractAmount"
                :disabled="true"
              ></el-input>
            </div>

            <!--右侧一览表表格数据  -->

            <el-table
              ref="multipleTable"
              :data="generaltableData"
              border
              size="mini"
              style="width: 80%"
            >
              <!-- <el-table-column type="selection" width="50"></el-table-column> -->
              <el-table-column type="index" width="100" label="序号"></el-table-column>
              <el-table-column
                v-for="(item,index) in generltableColumn"
                :key="index"
                :prop="item.class"
                :label="item.labelName"
                :sortable="item.sortEnable"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="item.isNumFilter">{{scope.row[scope.column.property]|numFilter}}</span>
                  <span v-else>{{scope.row[scope.column.property]}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--财务分类 子分类表  -->
          <div class="orderClassifyRight" v-show="!tabVisible">
            <!--右侧表格数据  -->
            <el-table
              ref="multipleTable"
              :data="subtableData"
              border
              size="mini"
              style="width: 80%"
              height="100%"
            >
              <el-table-column type="index" width="100" label="序号"></el-table-column>
              <el-table-column prop="partyBName" label="合作单位" width="300"></el-table-column>
              <el-table-column prop="typeValue" label="合作金额">
                <template slot-scope="scope">
                  <span>{{scope.row[scope.column.property]|numFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    @click="subClassDetail(scope.row)"
                    type="text"
                    size="small"
                    v-if=" scope.row.partyBName!='合计'"
                  >查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="工程分类" name="second">
        <projectList
          :generalContractName="generalContractName"
          :projectId="projectId"
          :name="name"
          :projectTypeName="projectTypeName"
        ></projectList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getBasicDataListService, //获取财务、工程分类数据字典数据
  getFinanceOverAllService, //获取财务分类总览数据
  getFinanceDetailService, //获取财务分类明细数据
  getProjectOverAllService, //获取工程分类总览数据
  getProjectTypeDetailService, //获取工程分类章节数据
  getProjectsubDetailService //获取工程分类章节子目数据
} from "@/services/allContractServices";
import {
  BasicDataTwoDetailsService //获取二级数据字典内容
} from "@/services/sysSettingService";
import projectList from "./projectList";
import { numFilter } from "@/utils/filters";
export default {
  name: "ProjectMsgSet",
  components: {
    projectList
  },
  data() {
    return {
      category: "SUBFINANCETYPE", //分项合同财务类型
      classifyList: [], //财务分类左侧树
      pTypeKey: "0", //财务分类父类
      ProjectDateTree: [], //工程数
      generaltableData: [], //财务一览表表格数据
      subtableData: [], //子分类表格数据
      tabVisible: true,
      generalContractName: "", //总包合同名称
      generalContractAmount: 0, //总包合同总金额
      name: "", //项目名称
      projectTypeName: "", //项目类型
      subContractAmountTotal: 0, //记录财务分类子项统计数据
      generltableColumn: [
        {
          class: "typeName",
          labelName: "项目",
          sortEnable: false,
          width: 300
        },
        {
          class: "typeValue",
          labelName: "合同金额",
          sortEnable: false,
          width: 160,
          isNumFilter: true
        }
      ],
      defaultProps: {
        children: "children",
        label: "value",
        id: "id",
        isLeaf: "leaf"
      },
      selectData: null,
      projectId: 0, //存储id
      isShowMaskBox: 0,
      complCatName: "",
      limitTime: "",
      activeName: "first"
    };
  },
  created() {
    // this.getProjectTypeCode(this.category); //获取财务数据
    this.category = "SUBPROJECTTYPE"; //项目数数据
    this.getProjectTypeCode(this.category); //获取财务数据
    // this.getFinanceOverAllData(); //获取财务分类总览
  },
  methods: {
    onActive() {
      this.activeName = "first";
      this.projectId = this.tabRouteParam.id;
      this.generalContractName = this.tabRouteParam.generalContractName; //总包合同名称
      this.name = this.tabRouteParam.name; //项目名称
      this.projectTypeName = this.tabRouteParam.projectTypeName; //项目类型
      this.getFinanceOverAllData();
    },
    //获取工程分类tree数据
    getProjectTypeCode(category) {
      let param = {};
      param.category = category;
      getBasicDataListService(param)
        .then(res => {
          if (res.code == 10000000) {
            if (category == "SUBPROJECTTYPE") {
              this.ProjectDateTree = res.data; //工程分类树
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定"
              });
            }
          }
        })
        .catch(error => {});
    },
    // 加载树结点
    loadNode(node, resolve) {
      // 如果是顶级的父节点
      if (node.level === 0) {
        // 查找顶级对象
        let reqParam = {};
        this.category = "SUBFINANCETYPE";
        reqParam.category = this.category;
        getBasicDataListService(reqParam)
          .then(res => {
            if (res.code == 10000000) {
              let nodes = res.data;
              if (nodes.length > 0) {
                nodes.forEach(item => {
                  item.pTypeKey = 0;
                });
                resolve(nodes);
              }
            } else {
              if (res.code > 20000000) {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定"
                });
              } else {
                this.$alert("系统异常", "提示", {
                  confirmButtonText: "确定"
                });
              }
            }
          })
          .catch(() => {
            let data = [];
            return resolve(data);
          });
      } else {
        // 根据父节点id找寻下一级的所有节点
        let param = {};
        param.pid = node.data.id;
        BasicDataTwoDetailsService(param)
          .then(res => {
            if (res.code == 10000000) {
              let nodes = res.data;
              if (nodes.length > 0) {
                nodes.forEach(item => {
                  item.leaf = true;
                  item.pTypeKey = node.data.label;
                });
                resolve(nodes);
              } else {
                resolve([]);
              }
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch(error => {
            this.$message.error("网络请求失败");
          });
      }
    },
    /* tree点击回调事件 */
    handleNodeClick(deptNode) {
      // this.deptSelected = deptNode;
      // this.departList[this.choiceindex].deptId = deptNode.id;
      if (undefined != deptNode.pTypeKey && null != deptNode.pTypeKey) {
        this.pTypeKey = deptNode.pTypeKey;
      }
      this.tabVisible = false;
      this.getFinanceSubData(deptNode.label);
    },
    //获取财务总览数据
    getFinanceOverAllData() {
      this.tabVisible = true;
      let reqParam = {
        projectId: this.projectId
      };
      getFinanceOverAllService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            this.generalContractAmount = numFilter(
              res.data.generalContractAmount
            );
            //bug 667 没有数据 现在只加了一个空的判断
            this.generaltableData = res?.data?.subContractFinanceTypesVOList?.length ?? [];
            let len = this.generaltableData.length;
            if (len > 0) {
              this.generaltableData[len] = {};
              this.generaltableData[len + 1] = {};
              this.generaltableData[len].typeName = "合计";
              this.generaltableData[len].typeValue = numFilter(
                res.data.subContractAmountTotal
              );
              this.generaltableData[len + 1].typeValue = numFilter(
                res.data.profit
              );
              this.generaltableData[len + 1].typeName = "毛利";
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },
    //获取财务分类子类数据
    getFinanceSubData(typeKey) {
      let key = typeKey.toString();
      let reqParam = {
        projectId: this.projectId,
        typeKey: key,
        pTypeKey: this.pTypeKey
      };
      getFinanceDetailService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            this.subtableData = res.data.subContractFinanceTypesVOList;
            this.subContractAmountTotal = res.data.subContractAmountTotal;
            if (undefined != this.subtableData && null != this.subtableData) {
              let len = this.subtableData.length;
              if (len >= 1) {
                this.subtableData[len] = {};
                this.subtableData[len].partyBName = "合计";
                this.subtableData[len].typeValue = this.subContractAmountTotal;
              }
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },

    //查看子分类列表一条数据详情 gaa 20200811
    subClassDetail(row) {
      this.$confirm("确定要查看吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let memberData = {};
        memberData.editFlag = false; //查看标志为1
        memberData.addFlag = 0; //新增标志为1
        memberData.id = row.contractId; //合同编号
        this.bus.$emit("navMenuChange", {
          //跳转相应的分项合同
          routeId: "totalApproveList",
          routeParam: memberData
        });
      });
    },

    handleTabClick(tab, event) {
      switch (this.activeName) {
        case "first":
          this.getFinanceOverAllData();
          break;
        case "second":
          break;
        default:
          break;
      }
    },
    closeBtn() {
      if (this.$refs.addForm) {
        this.addForm = {
          addComplCatName: "",
          addLimitTime: ""
        };
        this.$refs.addForm.resetFields();
      }
      this.isShowMaskBol = false;
    },
    //返回财务分类子类统计行数据
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "合计";
          return;
        }
        if (index === 2) {
          sums[index] = this.subContractAmountTotal;
          return;
        }
      });
      return sums;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.orderClassify,
.orderClassify1 {
  height: 100%;
  display: flex;
  justify-content: space-between;
  /deep/.el-tab-pane {
    height: 96%;
  }
  /deep/.el-tabs__header {
    padding-right: 0;
    background: #d5e7ed;
    .is-active {
      background: #ffffff;
    }
  }
  /deep/.el-tabs__content {
    height: calc(100% - 40px);
  }
}

/deep/.el-tree-node__content {
  height: 40px;
  font-size: 16px;
}

.orderClassifyLeft {
  width: 350px;
  height: 100%;
  padding: 24px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .orderClassifyLeftTitle {
    text-align: left;
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 600;
    margin-bottom: 16px;
    img {
      vertical-align: middle;
      float: right;
      margin: 5px 8px 0 0;
    }
  }

  .custom-tree-container {
    min-width: 302px;
    height: 800px;
    overflow: auto;
    padding-top: 18px;
    padding-left: 12px;
    box-sizing: border-box;
    margin: 0 auto;
    background: #f0f5f7;

    /deep/ .el-tree {
      background: none;
    }

    .custom-tree-node {
      //   width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .classifyBtn {
        width: 14px;
        height: 14px;
      }
      .lastclassifyBtn {
        margin-right: 16px;
      }
    }
  }
}
.orderClassifyRight {
  /*width: 100%;*/
  width: calc(100% - 340px);
  // height: 100%;
  background: #fff;
  margin-left: 16px;
  margin-top: 20px;
  padding: 24px;
  box-sizing: border-box;
  .classifyRightItem {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    .rightItemTitle {
      width: 125px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
      text-align: right;
      line-height: 14px;
    }
    .rightItemInput {
      width: 280px;
      height: 36px;
      margin-left: 16px;
    }
  }
  .classifyRightItem:last-child {
    margin-top: 16px;
  }
}
.maskBox {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  .maskContent {
    background: #fff;

    .titleBox {
      height: 32px;
      background-color: #e7e9e8;
      position: relative;

      .titleTxt {
        padding-left: 20px;
        color: #333;
        text-align: left;
        font-weight: bold;
        font-size: 13px;
        box-sizing: border-box;
        line-height: 32px;
      }

      .closeMaskBtn {
        position: absolute;
        top: 8px;
        right: 10px;
        width: 16px;
        height: 16px;

        img {
          width: 100%;
        }
      }
    }
    .tableList {
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .titleItem {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .titleTxt {
          width: 100px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #333333;
          letter-spacing: 0;
          text-align: right;
          line-height: 14px;
          margin-right: 16px;
        }
      }
    }
    .footBox {
      border-top: 1px solid #ddd;
      background: #f8f9fd;
      padding: 8px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      .footBtn {
        padding: 5px 35px;
        border-radius: 2px;
        color: #fff;
        border: 1px solid #00b1bd;
        background: #00b1bd;
      }

      .footBtn {
        margin-right: 10px;
      }
    }
  }
}
</style>
